// extracted by mini-css-extract-plugin
module.exports = {"card":"TrendingCard_card__2s15c","title":"TrendingCard_title__2g823","description":"TrendingCard_description__2Xtkt","img":"TrendingCard_img__3oqoK"};